import { useMutation } from "@tanstack/react-query"
import { ApiError, api } from "@/api/client"
import { Body, Params, Response } from "../../../../backend/src/routes/event/patch.types"
import { AxiosError } from "axios"
import useAuth from "@/hooks/useAuth"
import { enqueueSnackbar } from "notistack"
import { useIntl } from "react-intl"

export const updateEventRequest = async (token: string | undefined, body: Body & Params) => {
    const { data } = await api({ token }).patch<Response>(`event/${body.id}`, body)
    return data
}
export const useUpdateEventMutation = () => {
    const { accessToken } = useAuth()
    const intl = useIntl()
    return useMutation<Response, AxiosError<ApiError>, Body & Params>({
        mutationFn: (body) => updateEventRequest(accessToken, body),
        onError: () => {
            enqueueSnackbar(intl.formatMessage({ id: "errors.error-saving-event" }), { variant: "error" })
        },
    })
}
